import { Link } from "react-router-dom";
import { Phone, CalendarDays } from "lucide-react";
import WhatsAppIcon from "@/components/icons/WhatsAppIcon";
import { PHONE_PRIMARY_TEL, getWhatsAppUrl, WHATSAPP_BOOKING_INTRO } from "@/lib/constants";
import { trackCall, trackWhatsApp, track } from "@/lib/analytics";

const MobileBottomBar = () => (
  <div className="fixed bottom-0 left-0 right-0 z-[9998] md:hidden bg-card border-t border-border pb-[env(safe-area-inset-bottom)]">
    <div className="grid grid-cols-3 min-h-[56px]">
      <a
        href={PHONE_PRIMARY_TEL}
        onClick={() => trackCall("mobile_bar")}
        className="flex min-h-[56px] flex-col items-center justify-center gap-0.5 text-foreground hover:text-primary transition-colors"
      >
        <Phone className="h-5 w-5" />
        <span className="text-[10px] font-medium">Call</span>
      </a>
      <a
        href={getWhatsAppUrl(WHATSAPP_BOOKING_INTRO)}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => trackWhatsApp("mobile_bar")}
        className="flex min-h-[56px] flex-col items-center justify-center gap-0.5 bg-whatsapp text-whatsapp-foreground"
      >
        <WhatsAppIcon className="h-5 w-5" />
        <span className="text-[10px] font-medium">WhatsApp</span>
      </a>
      <Link
        to="/book-appointment"
        onClick={() => track("book_appointment_click", { source: "mobile_bar" })}
        className="flex min-h-[56px] flex-col items-center justify-center gap-0.5 text-foreground hover:text-primary transition-colors"
      >
        <CalendarDays className="h-5 w-5" />
        <span className="text-[10px] font-medium">Book</span>
      </Link>
    </div>
  </div>
);

export default MobileBottomBar;
